import actionTypes from './actionTypes'

const mediaSlidesActions = {
	mediaSlideFetched(mediaSlide, lessonUid, externalLessonUid, video) {
		return {
			type: actionTypes.MEDIA_SLIDE_FETCH_SUCCESS,
			mediaSlide,
			lessonUid,
			externalLessonUid,
			video,
		}
	},
	mediaSlideFetchedFailed(error, lessonUid) {
		return {
			type: actionTypes.MEDIA_SLIDE_FETCH_FAILED,
			error,
			lessonUid,
		}
	},
	myLibraryMediaSlideFetchFailed(error) {
		return {
			type: actionTypes.MEDIA_SLIDE_MY_LIBRARY_SLIDE_FETCH_FAILED,
			error,
		}
	},
	storeMediaSlideFetchFailed(error) {
		return {
			type: actionTypes.MEDIA_SLIDE_STORE_SLIDE_FETCH_FAILED,
			error,
		}
	},
	privateLibraryMediaSlideFetchFailed(error) {
		return {
			type: actionTypes.MEDIA_SLIDE_PRIVATE_LIBRARY_SLIDE_FETCH_FAILED,
			error,
		}
	},
	getPreviewMediaSlideFailed(error) {
		return {
			type: actionTypes.MEDIA_SLIDE_VIDEO_PREVIEW_SLIDE_FETCH_FAILED,
			error,
		}
	},
	getPreviewMediaSlideFetched(data) {
		return {
			type: actionTypes.MEDIA_SLIDE_VIDEO_PREVIEW_SLIDE_FETCH_SUCCESS,
			data,
		}
	},
}

export default mediaSlidesActions
